import React from 'react'

import Image from '../../image/image'

import './heroImage.css'

const HeroImage = ({ data }) => {
  return (
    <section className={'heroImage ' + (data.constrain ? 'constrain' : '')}>
      <Image file={data.image} alt="hero image" />
      {data.text && <h1>{data.text}</h1>}
    </section>
  )
}

export default HeroImage
